import React, { useState } from "react";
import ExperienceCard from "./ExperienceCard";
import experience from "../data/experience";

const Experience = () => {
  const [openExperience, setOpenExperience] = useState(null);

  return (
    <section className="bg-white px-6 py-10 text-zinc-950 dark:bg-zinc-950 dark:text-white">
      <div className="mx-auto mb-3 w-full max-w-3xl text-left">
        <h2 className="text-xl font-semibold">Experience</h2>
      </div>

      <div className="mx-auto flex w-full max-w-3xl flex-col items-center">
        {experience.map((exp, index) => (
          <ExperienceCard
            key={index}
            experience={exp}
            isOpen={openExperience}
            setOpenExperience={setOpenExperience}
          />
        ))}
      </div>
    </section>
  );
};

export default Experience;
